import { useState, useEffect } from 'react';
import { Validator } from 'blaze-validator';
import { AxiosResponse } from 'axios';
import Form from '../form/Form';
import ApiService from '../../services/ApiService';
import { getCardImageByBin, getCardImageByName } from './PaymentUtil';
import LoadingPage from '../LoadingPage';

interface SavedCard {
  bin: string;
  exp: string;
  last4: string;
  type: string;
  token: string;
}
interface Props {
  customerNum?: string;
  cards?: SavedCard[];
  onSelect: ({ token, amount, card }: { token: string; amount: number; card?: SavedCard }) => void;
  amount: string | number;
}

const SavedCardForm = ({ customerNum, cards, amount, onSelect }: Props) => {
  const [savedCards, setSavedCards] = useState<SavedCard[] | null>(null);

  useEffect(() => {
    if (customerNum && !cards) {
      ApiService.get(`customer/${customerNum}/cards`).then((response: AxiosResponse) => {
        setSavedCards(response.data);
      });
    }

    if (cards) {
      setSavedCards(cards);
    }
  }, []);

  const getSavedCardOptions = () => {
    if (!savedCards) {
      return [];
    }

    return savedCards.map((card: SavedCard, index: number) => {
      const cardImage = card.type ? getCardImageByName(card.type) : getCardImageByBin(card.token);

      return {
        value: card.token,
        label: (
          <div key={String(index)}>
            <img src={cardImage} style={{ height: '25px' }} /> Last 4: <strong>{card.last4}</strong> - Exp:{' '}
            {card.exp.replace(/[^\d]*/g, '').replace(/^(\d\d)/, '$1/')}
          </div>
        ),
      };
    });
  };

  const getSelectedCard = (token: string) => {
    if (!savedCards) {
      return;
    }

    for (const card of savedCards) {
      if (token === card.token) {
        return card;
      }
    }
  };

  const handleSubmit = ({ token }: { token: string }) => {
    return onSelect({ token, amount: parseFloat(String(amount)), card: getSelectedCard(token) });
  };

  if (!savedCards) {
    return <LoadingPage />;
  }

  if (savedCards && !savedCards.length) {
    return <>No saved cards found</>;
  }

  const layout = [
    {
      control: 'ReactSelect',
      name: 'token',
      options: getSavedCardOptions(),
      label: 'Select Saved Card',
    },
  ];

  return (
    <Form
      layout={layout}
      submit={handleSubmit}
      exportFormat="object"
      submitAll={true}
      trackDirty={false}
      hideCancel={true}
      submitLabel={`Pay ${Validator.sanitize('currency', amount, { precision: 2 })}`}
    />
  );
};

export default SavedCardForm;
